import react from "react";

import calliope1 from "../images/commercials/calliope/CALLIOPE_001 Large.jpeg";
import calliope2 from "../images/commercials/calliope/CALLIOPE_002 Large.jpeg";
import calliope3 from "../images/commercials/calliope/CALLIOPE_003 Large.jpeg";
import calliope4 from "../images/commercials/calliope/CALLIOPE_004 Large.jpeg";
import calliope5 from "../images/commercials/calliope/CALLIOPE_005 Large.jpeg";
import calliope6 from "../images/commercials/calliope/CALLIOPE_006 Large.jpeg";
import calliope7 from "../images/commercials/calliope/CALLIOPE_007 Large.jpeg";
import calliope8 from "../images/commercials/calliope/CALLIOPE_008 Large.jpeg";

const Calliope = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={calliope1} alt="Calliope Commercial Photography - Image 1"/>
                </div>
                <div className="single portrait">
                    <img src={calliope2} alt="Calliope Commercial Photography - Image 2"/>
                </div>
                <div className="single portrait">
                    <img src={calliope3} alt="Calliope Commercial Photography - Image 3"/>
                </div>
                <div className="single portrait">
                    <img src={calliope4} alt="Calliope Commercial Photography - Image 4"/>
                </div>
                <div className="single portrait">
                    <img src={calliope5} alt="Calliope Commercial Photography - Image 5"/>
                </div>
                <div className="single portrait">
                    <img src={calliope6} alt="Calliope Commercial Photography - Image 6"/>
                </div>
                <div className="single portrait">
                    <img src={calliope7} alt="Calliope Commercial Photography - Image 7"/>
                </div>
                <div className="single portrait">
                    <img src={calliope8} alt="Calliope Commercial Photography - Image 8"/>
                </div>
            </div>
        </div>
    );
}

export default Calliope;